@if (isLoaded()) {
  <div id="container-operations" class="d-flex align-items-stretch">

    <div class="menu-operations me-2">
      <ul class="nav flex-column ms-2">
        @for (item of arrayMenu; track item.tab) {
          <li class="nav-item item-operations">
            <a class="nav-link"
               [routerLink]="getTabLink(item.routePath)"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: false}">
              {{ item.translatedName }}
            </a>
          </li>
        }
      </ul>
    </div>

    <div class="operations-content">
      <router-outlet></router-outlet>
    </div>

  </div>
}
